import { createSelector } from 'reselect'

export const getLocations = createSelector(
  (state) => state.geoObjects && state.geoObjects.locations && state.geoObjects.locations.elements
    ? state.geoObjects.locations.elements
    : [],
  (locations) => locations
)
